import { useEffect } from "react";

// ----------------------------------------------------------------------

export function useWaitForDatalayer(callback) {
    useEffect(() => {
        let isMounted = true;

        function checkDataLayer() {
            if (Array.isArray(window.dataLayer)) {
                if (isMounted) {
                    callback(window.dataLayer);
                }
            } else {
                setTimeout(checkDataLayer, 300); // Retry every 300ms
            }
        }

        checkDataLayer();

        return () => {
            isMounted = false;
        };
    }, [callback]);
}
